import { h } from "./createElement";
import { __assign } from "tslib";
import * as React from 'react';
import ReactDOM from 'react-dom';
import { emptyFn, inject } from './helper';
import flatten from 'lodash/flatten';
export var ShowCloseContext = React.createContext(emptyFn);
export function showWithTransition(_a) {
    var Component = _a.Component, transitionDuration = _a.transitionDuration, autoClose = _a.autoClose, props = _a.props, forcedProps = _a.forcedProps, _b = _a.injectClosePropNames, injectClosePropNames = _b === void 0 ? [] : _b, _c = _a.deepInjectClosePaths, deepInjectClosePaths = _c === void 0 ? [] : _c, _d = _a.contexts, contexts = _d === void 0 ? [] : _d;
    var div = document.createElement('div');
    document.body.appendChild(div);
    var timer;
    var closed = false;
    injectClose(props);
    var currentProps = __assign(__assign(__assign({}, props), forcedProps), { visible: true });
    function overrideSingle(obj, key) {
        var originalValue = obj[key] || emptyFn;
        if (originalValue.__dui_injected_fn__) {
            return;
        }
        obj[key] = inject(originalValue, close);
    }
    function injectClose(propsToInject) {
        injectClosePropNames.forEach(function (key) {
            overrideSingle(propsToInject, key);
        });
        deepInjectClosePaths.forEach(function (path) {
            var segments = path.split('.');
            var finalKey = segments.pop();
            var objectWalkers = [propsToInject];
            var _loop_1 = function (seg) {
                var nextLevelObjects = flatten(objectWalkers.map(function (obj) { return obj[seg]; }).filter(function (value) { return value; }));
                if (!nextLevelObjects.length) {
                    return { value: void 0 };
                }
                objectWalkers = nextLevelObjects;
            };
            for (var _i = 0, segments_1 = segments; _i < segments_1.length; _i++) {
                var seg = segments_1[_i];
                var state_1 = _loop_1(seg);
                if (typeof state_1 === "object")
                    return state_1.value;
            }
            objectWalkers.forEach(function (obj) {
                overrideSingle(obj, finalKey);
            });
        });
    }
    function update(newProps) {
        if (closed) {
            return;
        }
        currentProps = __assign(__assign(__assign(__assign({}, currentProps), newProps), forcedProps), { visible: true });
        injectClose(currentProps);
        render(currentProps);
    }
    function close() {
        if (closed) {
            return;
        }
        closed = true;
        clearTimeout(timer);
        currentProps = __assign(__assign({}, currentProps), { visible: false });
        render(currentProps);
        setTimeout(function () {
            ReactDOM.unmountComponentAtNode(div);
            div.remove();
        }, transitionDuration + 20);
    }
    var effectiveContexts = [{ provider: ShowCloseContext.Provider, value: close }].concat(contexts);
    function render(props) {
        ReactDOM.render(composeContexts(effectiveContexts, h(Component, __assign({}, props))), div);
    }
    render(currentProps);
    if (autoClose) {
        timer = setTimeout(close, props.duration || 2000);
    }
    return { update: update, close: close };
}
function composeContexts(contexts, children) {
    return contexts.reduce(function (child, _a) {
        var Provider = _a.provider, value = _a.value;
        return h(Provider, { value: value }, child);
    }, children);
}
